module.exports = __webpack_public_path__ + "static/media/wegovy-green-bg-w-cercle.b32dde14.png";